import React, {useContext, useEffect, useRef} from "react";
import {useHistory, Link, useLocation} from "react-router-dom";
import appContext from "../../../context/appContext";
import styles from "./toolBar/ToolBar.module.scss";
import Button from "../../Componnets/mainButton/Button";
import http from "../../../services/api/utilities/http";

const coreFeatures = [
  {
    id: 1,
    title: "Process Explorer",
    link: "process-explorer",
    icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.89185 12.4601L8.21908 8.21908L12.4601 6.89185L11.1329 11.1329L6.89185 12.4601Z" stroke="#0A195C" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="9.6759" cy="9.6759" r="8.00915" stroke="#0A195C" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    buttonWidth: 176,
  },
  {
    id: 6,
    title: "Variant Explorer",
    link: "variant-explorer",
    icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.60826 13.8274H3.35767" stroke="#0A195C" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.9504 5.75023H16.201" stroke="#0A195C" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M7.27183 5.70521C7.27183 4.6255 6.39002 3.75 5.30254 3.75C4.21505 3.75 3.33325 4.6255 3.33325 5.70521C3.33325 6.78492 4.21505 7.66042 5.30254 7.66042C6.39002 7.66042 7.27183 6.78492 7.27183 5.70521Z" stroke="#0A195C" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M16.6666 13.7948C16.6666 12.7151 15.7855 11.8396 14.698 11.8396C13.6098 11.8396 12.728 12.7151 12.728 13.7948C12.728 14.8745 13.6098 15.75 14.698 15.75C15.7855 15.75 16.6666 14.8745 16.6666 13.7948Z" stroke="#0A195C" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    buttonWidth: 164,
  },
  {
    id: 3,
    title: "Conformance Checking",
    link: "conformance-checking-list",
    icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M14.3983 11.5743C14.9606 11.5743 15.4325 12.0383 15.3466 12.5936C14.8422 15.8603 12.0457 18.2857 8.67289 18.2857C4.94131 18.2857 1.91675 15.2611 1.91675 11.5304C1.91675 8.45674 4.25184 5.59359 6.88078 4.94622C7.4457 4.80674 8.02464 5.20411 8.02464 5.78569C8.02464 9.72604 8.1571 10.7453 8.90534 11.2997C9.65359 11.8541 10.5334 11.5743 14.3983 11.5743Z" stroke="#0A195C" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M18.0773 8.293C18.122 5.76142 15.0124 1.68072 11.2229 1.75089C10.9282 1.75616 10.6922 2.00177 10.679 2.29563C10.5834 4.37721 10.7124 7.07458 10.7843 8.29738C10.8062 8.67809 11.1053 8.97721 11.4852 8.99914C12.7422 9.07107 15.5378 9.16931 17.5896 8.85879C17.8685 8.81668 18.0729 8.57458 18.0773 8.293Z" stroke="#0A195C" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    fullSize: true
  },
  {
    id: 4,
    title: "Data Analysis",
    link: "data-analysis",
    icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.03735 12.318L8.53163 9.07622L11.3768 11.3112L13.8177 8.16089" stroke="#0A195C" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="16.6629" cy="3.50027" r="1.60183" stroke="#0A195C" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.437 2.6001H6.38054C3.87101 2.6001 2.31494 4.37737 2.31494 6.8869V13.6222C2.31494 16.1318 3.84049 17.9014 6.38054 17.9014H13.5506C16.0602 17.9014 17.6162 16.1318 17.6162 13.6222V7.75647" stroke="#0A195C" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    buttonWidth: 156,
  },
  {
    id: 2,
    title: "BPMN Models",
    link: "bpmn-models",
    icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M2.5 5.41667C2.5 3.22899 2.52342 2.5 5.41667 2.5C8.30991 2.5 8.33333 3.22899 8.33333 5.41667C8.33333 7.60434 8.34256 8.33333 5.41667 8.33333C2.49077 8.33333 2.5 7.60434 2.5 5.41667Z" stroke="#0A195C" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M11.6667 5.41667C11.6667 3.22899 11.6902 2.5 14.5834 2.5C17.4767 2.5 17.5001 3.22899 17.5001 5.41667C17.5001 7.60434 17.5093 8.33333 14.5834 8.33333C11.6575 8.33333 11.6667 7.60434 11.6667 5.41667Z" stroke="#0A195C" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M2.5 14.5834C2.5 12.3957 2.52342 11.6667 5.41667 11.6667C8.30991 11.6667 8.33333 12.3957 8.33333 14.5834C8.33333 16.7711 8.34256 17.5001 5.41667 17.5001C2.49077 17.5001 2.5 16.7711 2.5 14.5834Z" stroke="#0A195C" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M11.6667 14.5834C11.6667 12.3957 11.6902 11.6667 14.5834 11.6667C17.4767 11.6667 17.5001 12.3957 17.5001 14.5834C17.5001 16.7711 17.5093 17.5001 14.5834 17.5001C11.6575 17.5001 11.6667 16.7711 11.6667 14.5834Z" stroke="#0A195C" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    buttonWidth: 184,
  },
  {
    id: 5,
    title: "Process Compare",
    link: "process-compare",
    icon: <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.8396 17.1642V3.54645" stroke="#FF0053" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.9172 13.0681L14.8395 17.1648L10.7617 13.0681" stroke="#FF0053" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.91112 0.832886V14.4507" stroke="#FF0053" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M0.83345 4.929L4.91123 0.832336L8.98901 4.929" stroke="#FF0053" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    fullSize: true,
  },
]

const ToolBar = (props) => {
  const history = useHistory();
  const location = useLocation();
  const context = useContext(appContext);
  const [showPopup, setShowPopup] = React.useState(false);
  const popupRef = useRef(null)

  const handleTriggerShowPopup = () => {
    setShowPopup(!showPopup)
  }

  const handleAddTab = (id, title, link) => {
    history.push(link);
    context.handleAddTab(id, title, link);
    setShowPopup(!showPopup)
  }

  const saveTabs = () => {
    if(location.pathname === '/map') return;
      context.dispatch({type:'set_variants_process_map',value:[]})
      context.dispatch({type:'set_active_variants_process_map',value:[]})
      context.dispatch({type:'set_process_explorer_filters',value:[]})
      context.dispatch({type:'set_process_explorer_flow',value:[]})
      context.dispatch({type:'set_process_explorer_variants',value:[]})
      context.dispatch({type:'set_process_explorer_active_variants',value:[]})
      context.handleAutoSave({
        processCompareFilters: [],
        processCompareVariants: [],
        processCompareFlow: [],
        processMapFilters: [],
        processMapVariants: [],
        processMapFlow:[],
      })
    const openTabs = context.openTabs
    let id = context.handleUid().id
    http.post('process_mining/save_tabs_state/'+id,
        {
          'tabs_config': {openTabs,activeTab:location.pathname},
        }).then(()=>{

    })
  }

  const experimental = <div className={styles.experimental}>
    <span>EXPERIMENTAL</span>
  </div>

  const handleOutsideClick = e => {
    if (!popupRef?.current?.contains(e.target)) {
      setShowPopup(!showPopup);
    }
  };

  useEffect(() => {
    if (showPopup) {
      document.addEventListener("click", handleOutsideClick, false);
    }
    return function cleanupListener() {
      document.removeEventListener('click', handleOutsideClick, false)
    }
  }, [showPopup]);

  return (
    !history.location.pathname.includes("share/data_analysis") && <div className={`row align-items-center ${styles.ToolBar}`}>
      <div className="col-sm-12">
        <div className={`row ${styles.toolBarContainer}`}>
          <div className={'d-flex'}>
            <div  className={'d-flex align-items-center ml-1'}>
              <Link onClick={saveTabs}  to="/dashboard/workspace">
                <i><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M2.75 7.666L2.75 16.335C2.75 19.355 4.889 21.25 7.916 21.25L16.084 21.25C19.111 21.25 21.25 19.365 21.25 16.335L21.25 7.666C21.25 4.636 19.111 2.75 16.084 2.75L7.916 2.75C4.889 2.75 2.75 4.636 2.75 7.666Z" stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M7.91406 12L16.0861 12" stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M11.6777 15.748L7.91373 12L11.6777 8.25195" stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                </i>
              </Link>
            </div>
            <span className={['d-flex', 'flex-column', styles.pageTitle].join(" ")}>
              {/*<div>{props.dataHeader}</div>*/}
              <div>{context.handleSelectedWorkspaceInfo().name}</div>
              <div className={styles.boldText}>{context.handleUid().name}</div>
            </span>
            <div className={styles.addNewTabSection}>
              <div className={styles.addNewTabButton}>
                <Button
                  onClick={handleTriggerShowPopup}
                  type={"outlined"}
                  color={showPopup ? "primary" : "secondary"}
                  size={"medium"}
                  textSize={"textLight"}
                  hoverOutlined
                  block
                  leftIcon={<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.66663 10.0001H13.3333M9.99996 6.66675L9.99996 13.3334" stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round"/>
                  </svg>}
                >
                  Add New Tab
                </Button>
              </div>
              {
                showPopup && <div ref={popupRef} className={styles.popup}>
                  <div className={styles.popupTitle}>
                    Case Features
                  </div>
                  <div className={"d-flex flex-wrap justify-content-between"}>
                    {
                      coreFeatures.map((item, index) => (
                        <div className={[
                          'd-flex',
                          'flex-wrap',
                        ].join(' ')}
                             key={`${index}_${item.title}`}
                             style={{width: item.fullSize ? "100%" : item.buttonWidth, marginBottom: 16}}
                        >
                          <Button
                            onClick={() => handleAddTab(item.id, item.title, item.link)}
                            type={"outlined"}
                            color={"secondary"}
                            size={"medium"}
                            hoverOutlined
                            block
                            leftIcon={item.icon}
                          >
                            {item.title}
                          </Button>
                        </div>
                      ))
                    }
                  </div>
                </div>
              }
            </div>

          </div>
        </div>
      </div>
    </div>
  )
};

export default ToolBar;

